function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.413.918a1 1 0 01.085 1.412l-7.68 8.667a1 1 0 01-1.418.079l-4.32-3.9A1 1 0 012.42 5.69l3.571 3.224 7.01-7.911a1 1 0 011.412-.086z",
  fill: "#333"
});

function SvgThickCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC40MTMyIDAuOTE4MzM0QzE0LjgyNjYgMS4yODQ2MiAxNC44NjQ3IDEuOTE2NjQgMTQuNDk4NCAyLjMyOTk4TDYuODE4NDMgMTAuOTk2NkM2LjY0MTQ3IDExLjE5NjMgNi4zOTIwNSAxMS4zMTcgNi4xMjU2NSAxMS4zMzE5QzUuODU5MjQgMTEuMzQ2NyA1LjU5Nzk1IDExLjI1NDUgNS4zOTk5IDExLjA3NTdMMS4wNzk5IDcuMTc1NjlDMC42Njk5NjIgNi44MDU2MSAwLjYzNzY1MiA2LjE3MzI3IDEuMDA3NzQgNS43NjMzMkMxLjM3NzgzIDUuMzUzMzggMi4wMTAxNyA1LjMyMTA3IDIuNDIwMTEgNS42OTExNkw1Ljk5MDk2IDguOTE0ODRMMTMuMDAxNiAxLjAwMzU0QzEzLjM2NzkgMC41OTAxOTYgMTMuOTk5OSAwLjU1MjA0OCAxNC40MTMyIDAuOTE4MzM0WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";
export { SvgThickCheck as ReactComponent };